<template>
  <v-select
    dense
    filled
    multiple
    :label="label"
    :hint="question.instructionText"
    persistentHint
    :disabled="disabled"
    v-model="question.value"
    :items="choices"
    item-text="choiceLabel"
    item-value="choiceValue"
    :rules="[required ? rules.required : true]"
  >
  </v-select>
</template>

<script>
import QuestionMixin from "./QuestionMixin";

export default {
  name: "ComboboxQuestion",
  methods: {
    evaluateAllExpressions() {
      this.question.expressions.forEach(expression => {
        let satisfied = false;
        switch (expression.condition) {
          case "isBlank":
            satisfied = this.question.value.length === 0;
            break;
          case "isNotBlank":
            satisfied = this.question.value.length > 0;
            break;
          case "is":
            satisfied =
              this.question.value.length === 1 &&
              this.question.value[0] === expression.value.value;
            break;
          case "contains":
            satisfied = this.question.value.some(
              val => val === expression.value.value
            );
            break;
          case "isNot": //Not sure what isNot even means, so implementing the same as doesNotContain
          case "doesNotContain":
            satisfied = !this.question.value.some(
              val => val === expression.value.value
            );
            break;
          default:
            break;
        }
        this.$set(expression, "satisfied", satisfied);
      });
    }
  },
  mixins: [QuestionMixin],
  data() {
    return {
      rules: {
        required: value => value.length > 0 || "Required"
      }
    };
  },
  computed: {
    choices() {
      if (!this.question.choices || !this.question.choices.length) return [];

      return this.question.choices.map(choice => {
        if (typeof choice === "object")
          return { choiceLabel: choice.text, choiceValue: choice.value };
        else throw new Error("Unknown choice type", choice);
      });
    }
  }
};
</script>

<style scoped></style>
